import {
  AgeRangeFilter,
  FilterScopeProvider,
  HeightRangeFilter,
  MinutesPlayedFilter,
  NationalityFilter,
  PITCH_POSITION_KEYS,
  PitchPositionFilter,
  PreferredFootFilter,
} from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrap } from 'jotai/utils';
import { useTranslation } from 'react-i18next';
import { playerNationalityOptionsAtom } from '@/atoms/queries/players';
import { PREFERRED_FOOT } from '@/consts/preferredFoot';

const unwrappedNationalityOptionsAtom = unwrap(playerNationalityOptionsAtom, prev => prev ?? null);

const PlayerDataLockerPlayerFiltersContent = () => {
  const { t } = useTranslation('events');
  const positionLabels = Object.fromEntries(
    PITCH_POSITION_KEYS.map(key => [key, t(`fields.event.attributes.playerPosition.${key}`)]),
  );
  const nationalityOptions = useAtomValue(unwrappedNationalityOptionsAtom);
  const preferredFootOptions = PREFERRED_FOOT.map(value => ({
    label: t(`fields.player.preferredFoot.${value.toLowerCase()}`),
    value,
  }));

  return (
    <>
      <PitchPositionFilter labels={positionLabels} />
      <AgeRangeFilter />
      <HeightRangeFilter />
      <MinutesPlayedFilter />
      <NationalityFilter options={nationalityOptions ?? []} isLoading={nationalityOptions === null} />
      <PreferredFootFilter options={preferredFootOptions} />
    </>
  );
};

export const PlayerDataLockerPlayerFilters = () => (
  <FilterScopeProvider scope="main">
    <PlayerDataLockerPlayerFiltersContent />
  </FilterScopeProvider>
);
